const cs = {
  premiumInterview: {
    badge: "Prémiový AI zážitek",
    heroTitle1: "AI Avatar pohovor",
    heroTitle2: "v reálném čase",
    windowTitle: "HireThink Prémiový živý AI pohovor",
    heroSubtitle:
      "Poskytněte kandidátům skutečný zážitek z pohovoru díky nejmodernější AI technologii. Proměňte svůj náborový proces živými avatary, přirozenou konverzací a okamžitou analýzou.",
    imageAlt: "Prémiový zážitek z pohovoru s AI avatarem",
    floatBadge1Title: "Pohovory 24/7",
    floatBadge1Desc: "Vždy připraveno",
    floatBadge2Title: "Neomezený počet kandidátů",
    floatBadge2Desc: "Současně",
    floatBadge3Title: "Přirozený dialog",
    floatBadge3Desc: "Realistický zážitek",
    featuresTitle: "Funkce prémiového pohovoru",
    featuresSubtitle: "Zážitek z pohovoru poháněný nejmodernější AI technologií",
    feature1Title: "Více možností avatarů",
    feature1Desc:
      "Vyberte avatara, který nejlépe odpovídá vaší společnosti, z široké škály vzhledů a osobností. Každý avatar poskytuje profesionální a důvěryhodný zážitek z pohovoru.",
    feature2Title: "Doladění pro konkrétní firmu",
    feature2Desc:
      "Rychle upravte výslovnost slov, která se vám nelíbí, nebo oborových termínů — přizpůsobeno vaší firmě. Nechte avatara mluvit přesně tak, jak chcete.",
    feature3Title: "Pokročilá detekce anomálií",
    feature3Desc:
      "Detekuje neobvyklé chování analýzou pohybu očí, výrazů obličeje a tónu hlasu. Chrání integritu pohovoru.",
    feature4Title: "Podpora více jazyků",
    feature4Desc:
      "Přirozená řeč ve více než 30 jazycích. Porozumějte různým přízvukům a získejte přístup ke globálnímu talentu s přesnou výslovností.",
    feature5Title: "Bezpečné a v souladu s KVKK",
    feature5Desc:
      "Všechny záznamy pohovorů jsou uloženy šifrovaně na zabezpečených serverech. Plně v souladu se standardy KVKK a GDPR.",
    feature6Title: "Podrobné analytické reporty",
    feature6Desc:
      "Rozhodujte se na základě dat pomocí hodnocení podle kompetencí, sentiment analýzy a srovnávacích hodnocení.",
    benefitsTitle: "Proč prémiový pohovor?",
    benefitsSubtitle: "Posuňte svůj náborový proces na další úroveň",
    benefit1: "Nabídněte kandidátům skutečný zážitek z pohovoru",
    benefit2: "Ušetřete čas a náklady",
    benefit3: "Spravedlivé a standardizované hodnocení pro každého kandidáta",
    benefit4: "Nepřetržitá dostupnost pohovorů 24/7",
    benefit5: "Rozhodujte se správně díky podrobné analytice kompetencí",
    benefit6: "Posilte image své značky zaměstnavatele",
    ctaTitle: "Vyzkoušejte prémiový AI pohovor",
    ctaSubtitle: "Vyžádejte si ukázku ještě dnes a proměňte svůj náborový proces",
    ctaButton: "Vyžádat ukázku"
  },

  standardInterview: {
    heroTitle1: "Standardní video",
    heroTitle2: "AI pohovor",
    windowTitle: "HireThink Standardní video AI pohovor",
    heroSubtitle:
      "Nechte AI vést asynchronní video pohovory; AI generuje videa tazatele, poskytuje okamžité skóre a vytváří sdílitelné reporty.",
    imageAlt: "Zážitek ze standardního video AI pohovoru",
    floatBadge1Title: "Pohovory 24/7",
    floatBadge1Desc: "Vždy připraveno",
    floatBadge2Title: "Neomezený počet kandidátů",
    floatBadge2Desc: "Současně",
    floatBadge3Title: "Pokročilé přizpůsobení",
    floatBadge3Desc: "1000+ připravených avatarů",
    featuresTitle: "Funkce standardního videa",
    featuresSubtitle: "Spolehlivé asynchronní video pohovory s transparentním hodnocením",
    feature1Title: "1000+ možností avatarů",
    feature1Desc:
      "Vyberte to nejlepší pro vaši firmu z mnoha různých avatarů — nebo si vytvořte vlastního avatara.",
    feature2Title: "Doladění pro konkrétní firmu",
    feature2Desc:
      "Rychle upravte výslovnost slov, která se vám nelíbí, nebo oborových termínů; nechte avatara mluvit přesně tak, jak chcete.",
    feature3Title: "Pokročilá detekce anomálií",
    feature3Desc:
      "Analyzuje pohyby kandidáta a aktivitu v prohlížeči, hlásí neobvyklé situace a uchovává je zaznamenané v reportu.",
    feature4Title: "Podpora více jazyků",
    feature4Desc: "Přirozená řeč ve více než 30 jazycích; rozpoznávání přátelské k přízvukům a přesná výslovnost.",
    feature5Title: "Bezpečné a v souladu s KVKK",
    feature5Desc: "Záznamy jsou šifrovány na zabezpečených serverech; v souladu s KVKK/GDPR.",
    feature6Title: "Podrobné analytické reporty",
    feature6Desc:
      "Rozhodujte se na základě dat díky skóre podle kompetencí, skóre otázek a odpovědí, detekci anomálií a srovnávacím hodnocením.",
    ctaTitle: "Vyzkoušejte standardní AI pohovor",
    ctaSubtitle: "Vyžádejte si ukázku ještě dnes a proměňte svůj náborový proces",
    ctaButton: "Vyžádat ukázku"
  },

  voiceInterview: {
    heroTitle1: "Hlasový",
    heroTitle2: "AI pohovor",
    windowTitle: "HireThink Hlasový AI pohovor",
    heroSubtitle: "AI pohovor podobný telefonátu bez nutnosti plánování — přirozený dialog a okamžité hodnocení.",
    imageAlt: "Zážitek z hlasového AI pohovoru",
    floatBadge1Title: "Pohovory 24/7",
    floatBadge1Desc: "Vždy připraveno",
    floatBadge2Title: "Neomezený počet kandidátů",
    floatBadge2Desc: "Současně",
    floatBadge3Title: "Dostupné",
    floatBadge3Desc: "Snadné použití přes telefon",
    featuresTitle: "Funkce hlasového pohovoru",
    featuresSubtitle: "Nejdostupnější model pohovoru — analyzováno během několika minut",
    feature1Title: "Přístup odkudkoliv",
    feature1Desc:
      "Připojte se z jakéhokoli zařízení, odkudkoli; ideální řešení i pro slabé internetové připojení a nízké hardwarové nároky.",
    feature2Title: "Doladění pro konkrétní firmu",
    feature2Desc:
      "Rychle upravte výslovnost slov, která se vám nelíbí, nebo oborových termínů — přizpůsobeno vaší firmě. Nechte avatara mluvit přesně tak, jak chcete.",
    feature3Title: "Pokročilá detekce anomálií",
    feature3Desc:
      "Detekuje neobvyklé chování analýzou pohybu očí, výrazů obličeje a tónu hlasu. Chrání integritu pohovoru.",
    feature4Title: "Podpora více jazyků",
    feature4Desc:
      "Přirozená řeč ve více než 30 jazycích. Porozumějte různým přízvukům a získejte přístup ke globálnímu talentu s přesnou výslovností.",
    feature5Title: "Bezpečné a v souladu s KVKK",
    feature5Desc:
      "Všechny záznamy pohovorů jsou uloženy šifrovaně na zabezpečených serverech. Plně v souladu se standardy KVKK a GDPR.",
    feature6Title: "Podrobné analytické reporty",
    feature6Desc:
      "Rozhodujte se na základě dat pomocí hodnocení podle kompetencí, sentiment analýzy a srovnávacích hodnocení.",
    ctaTitle: "Vyzkoušejte hlasový AI pohovor",
    ctaSubtitle: "Vyžádejte si ukázku ještě dnes a proměňte svůj náborový proces",
    ctaButton: "Vyžádat ukázku"
  },

  whatsappInterview: {
    heroTitle1: "WhatsApp",
    heroTitle2: "AI pohovor",
    windowTitle: "HireThink WhatsApp pohovor",
    heroSubtitle: "Veďte písemné pohovory poháněné AI na platformě, kterou kandidáti používají denně. Sledujte stav hledání práce a posílejte aktualizace procesu — vše přes WhatsApp.",
    imageAlt: "Zážitek z WhatsApp AI pohovoru",
    floatBadge1Title: "Okamžitá interakce",
    floatBadge1Desc: "AI v reálném čase",
    floatBadge2Title: "Nulové tření",
    floatBadge2Desc: "Bez stahování aplikace",
    floatBadge3Title: "Aktualizace procesu",
    floatBadge3Desc: "Automatizovaná oznámení",
    featuresTitle: "Funkce WhatsApp pohovoru",
    featuresSubtitle: "Zážitek z AI pohovoru v reálném čase na platformě, kterou kandidáti používají denně",
    feature1Title: "Známá platforma, žádná křivka učení",
    feature1Desc: "Žádná aplikace ke stažení, žádný portál k naučení. Kandidáti se připojují přes WhatsApp — aplikaci, kterou už denně používají. Míra účasti na pohovorech přesahuje 90 %.",
    feature2Title: "AI interakce v reálném čase",
    feature2Desc: "AI okamžitě vyhodnocuje každou odpověď, řídí průběh konverzace a dynamicky posouvá sled otázek na základě odpovědí kandidáta.",
    feature3Title: "Sledování stavu hledání práce",
    feature3Desc: "Zjistěte, zda kandidát stále aktivně hledá novou pozici — přímo přes WhatsApp. Okamžitě přiveďte vhodné kandidáty do náborového procesu.",
    feature4Title: "Automatizovaná oznámení o procesu",
    feature4Desc: "Pozvánky na pohovor, připomínky, oznámení o výsledcích a aktualizace dalších kroků jsou kandidátům automaticky zasílány jako WhatsApp zprávy.",
    feature5Title: "Bezpečné a v souladu s GDPR",
    feature5Desc: "Všechna data konverzací jsou uložena šifrovaně na zabezpečených serverech. Plně v souladu se standardy KVKK a GDPR.",
    feature6Title: "Podrobný report kompetencí",
    feature6Desc: "Písemné odpovědi jsou hodnoceny AI pomocí hodnocení podle rubriky. Skóre kompetencí, silné stránky a oblasti rozvoje jsou dodány ve strukturovaném reportu.",
    ctaTitle: "Vyzkoušejte WhatsApp AI pohovor",
    ctaSubtitle: "Vyžádejte si ukázku ještě dnes a proměňte svůj náborový proces",
    ctaButton: "Vyžádat ukázku"
  },
  phoneInterview: {
    heroTitle1: "Telefonický",
    heroTitle2: "AI pohovor",
    windowTitle: "HireThink Telefonický pohovor",
    heroSubtitle: "HireThink AI volá kandidátovi z linky 0850. Plně automatizovaný, interaktivní hlasový pohovor v reálném čase — stačí jen telefon.",
    imageAlt: "Zážitek z telefonického AI pohovoru",
    floatBadge1Title: "Automatické vytáčení",
    floatBadge1Desc: "AI volá kandidátovi",
    floatBadge2Title: "Okamžité hodnocení",
    floatBadge2Desc: "Analýza v reálném čase",
    floatBadge3Title: "Jakýkoli telefon",
    floatBadge3Desc: "Bez nutnosti aplikace",
    featuresTitle: "Funkce telefonického pohovoru",
    featuresSubtitle: "Plně automatizovaný, interaktivní hlasový pohovor přes linku HireThink AI 0850",
    feature1Title: "Automatické vytáčení AI",
    feature1Desc: "HireThink AI volá kandidátovi z čísla 0850 307 80 61. Ve chvíli, kdy kandidát zvedne telefon, začíná personalizovaný pohovor — bez nutnosti dalšího přihlášení nebo odkazu.",
    feature2Title: "Zopakování otázky",
    feature2Desc: "Pokud kandidát otázku neslyšel nebo jí nerozuměl, může si vyžádat její zopakování hlasem. AI otázku jasně a klidně zopakuje.",
    feature3Title: "Přeplánování na vhodnější čas",
    feature3Desc: "Pokud kandidát v danou chvíli není dostupný, může uvést preferovaný den a čas. AI vytvoří schůzku a automaticky zavolá zpět v naplánovaný čas.",
    feature4Title: "Detekce odpovědí mimo téma",
    feature4Desc: "Pokud odpověď nesouvisí s otázkou, AI to rozpozná a zdvořile požádá kandidáta o relevantní odpověď — po celou dobu tak udržuje kvalitu pohovoru.",
    feature5Title: "Hlasová analýza v reálném čase",
    feature5Desc: "AI současně analyzuje obsah odpovědi, tón hlasu, plynulost a soulad s kompetencemi. Podrobný report kompetencí je hotový ihned po skončení hovoru.",
    feature6Title: "Plně automatizovaný proces",
    feature6Desc: "Vyhodnoťte stovky kandidátů současně bez jakéhokoli zapojení náborového pracovníka. Všechny hovory jsou automaticky nahrávány a reportovány.",
    ctaTitle: "Vyzkoušejte telefonický AI pohovor",
    ctaSubtitle: "Vyžádejte si ukázku ještě dnes a proměňte svůj náborový proces",
    ctaButton: "Vyžádat ukázku"
  },
  textInterview: {
    heroTitle1: "Textový",
    heroTitle2: "AI pohovor",
    windowTitle: "HireThink Textový AI pohovor",
    heroSubtitle: "Strukturované textové pohovory pro počáteční fázi výběru — poháněné AI hodnocením podle rubriky.",
    imageAlt: "Zážitek z textového AI pohovoru",
    floatBadge1Title: "Nízké náklady",
    floatBadge1Desc: "Nejlepší cena",
    floatBadge2Title: "Neomezený počet kandidátů",
    floatBadge2Desc: "Současně",
    floatBadge3Title: "Dostupné",
    floatBadge3Desc: "Přístup odkudkoli",
    featuresTitle: "Funkce textového pohovoru",
    featuresSubtitle: "Časný výběr díky nenáročným textovým pohovorům",
    feature1Title: "Přístup odkudkoliv",
    feature1Desc:
      "Připojte se z jakéhokoli zařízení, odkudkoli; ideální řešení i pro slabé internetové připojení a nízké hardwarové nároky.",
    feature2Title: "Rozmanitost otázek",
    feature2Desc:
      "Napište si vlastní otázky nebo je nechte vygenerovat AI. Hodnoťte kandidáty s různou úrovní a různými typy otázek.",
    feature3Title: "Detekce anomálií",
    feature3Desc:
      "Hlásí neobvyklé situace pomocí kontroly podobnosti, detekce odpovědí generovaných AI a analýzy aktivity v prohlížeči — vše uchovává v záznamu.",
    feature4Title: "Jazyková flexibilita",
    feature4Desc:
      "Podpora písemných pohovorů ve více než 30 jazycích, včetně turečtiny, angličtiny, němčiny, francouzštiny, španělštiny, italštiny, portugalštiny, nizozemštiny, polštiny, češtiny, švédštiny, norštiny a dánštiny.",
    feature5Title: "Bezpečné a v souladu s KVKK",
    feature5Desc:
      "Všechny záznamy pohovorů jsou uloženy šifrovaně na zabezpečených serverech. Plně v souladu se standardy KVKK a GDPR.",
    feature6Title: "Podrobné analytické reporty",
    feature6Desc:
      "Rozhodujte se na základě dat pomocí hodnocení podle kompetencí, sentiment analýzy a srovnávacích hodnocení.",
    ctaTitle: "Vyzkoušejte textový AI pohovor",
    ctaSubtitle: "Vyžádejte si ukázku ještě dnes a proměňte svůj náborový proces",
    ctaButton: "Vyžádat ukázku"
  },

  peerInterviewPage: {
    heroTitle1: "Výběr",
    heroTitle2: "peer-to-peer",
    windowTitle: "HireThink Peer pohovor",
    heroSubtitle: "Nechte kandidáty, kteří postoupili do finálního kola, vybrat hlasováním jejich potenciální budoucí kolegy z týmu.",
    imageAlt: "Zážitek z peer pohovoru",
    floatBadge1Title: "Týmové hlasování",
    floatBadge1Desc: "Výběr členy týmu",
    floatBadge2Title: "Anonymní systém",
    floatBadge2Desc: "Spravedlivé hodnocení",
    floatBadge3Title: "Volba velkých firem",
    floatBadge3Desc: "Používají globální giganti",
    featuresTitle: "Funkce peer pohovoru",
    featuresSubtitle: "Tým nejlépe ví, co tým potřebuje – rovný a spravedlivý výběrový proces",
    feature1Title: "Anonymní informace o kandidátech",
    feature1Desc: "Informace o kandidátech, kteří postoupili do finálního kola, jsou do systému nahrány anonymně. Každý člen týmu si může kandidáty prohlédnout přes odkaz zaslaný potenciálním členům týmu.",
    feature2Title: "Porovnání a hodnocení",
    feature2Desc: "Členové týmu si mohou podrobně prohlédnout a porovnat informace o kandidátech. Hodnotí každého kandidáta, aby určili nejvhodnějšího člena týmu.",
    feature3Title: "Anonymní otázky a odpovědi",
    feature3Desc: "Členové týmu mohou kandidátům klást otázky anonymně, pokud si to přejí. Když je otázka položena, kandidát dostane SMS upozornění a může se přihlásit a odpovědět anonymně.",
    feature4Title: "Transparentní proces",
    feature4Desc: "Odpovědi kandidátů jsou viditelné pro všechny členy týmu. To zajišťuje, že všichni mají stejné informace, a umožňuje spravedlivější hodnocení.",
    feature5Title: "Týmové hlasování",
    feature5Desc: "Po dokončení všech hodnocení jsou skóre od členů týmu sečtena a je vybrán nejvhodnější kandidát. Každý měl při výběru svého kolegy stejný hlas.",
    feature6Title: "Metoda globálních gigantů",
    feature6Desc: "Tato metoda, kterou používají velké společnosti jako Google, Stripe, LinkedIn, GitLab, Atlassian a Amazon, je oblíbená, protože tým nejlépe ví, co tým potřebuje.",
    ctaTitle: "Vyzkoušejte peer pohovor",
    ctaSubtitle: "Vyžádejte si ukázku ještě dnes a zahajte svůj týmový výběrový proces",
    ctaButton: "Vyžádat ukázku"
  },

  cvScoring: {
    heroTitle1: "Hodnocení CV",
    heroTitle2: "založené na AI",
    windowTitle: "HireThink Hodnocení CV",
    heroSubtitle:
      "Shromážděte všechny přihlášky na jedné stránce, vyhodnoťte CV v různých formátech pomocí AI a ohodnoťte je podle vlastních kritérií.",
    imageAlt: "Dashboard hodnocení CV",
    floatBadge1Title: "Rychlá analýza",
    floatBadge1Desc: "Hodnocení během sekund",
    floatBadge2Title: "Přizpůsobeno vašim potřebám",
    floatBadge2Desc: "Vytvořte kritéria z pracovní nabídky",
    floatBadge3Title: "Podrobný report",
    floatBadge3Desc: "Komplexní analýza",
    featuresTitle: "Funkce hodnocení CV",
    featuresSubtitle: "Zrychlete svůj náborový proces díky hodnocení CV založenému na AI",
    feature1Title: "Snadné podání, snadné sledování",
    feature1Desc:
      "Shromážděte všechny přihlášky na jedné platformě a snadno je sledujte. Sledujte a spravujte stav přihlášek v reálném čase.",
    feature2Title: "Podrobné analýzy",
    feature2Desc:
      "Získejte komplexní analytické reporty pro každé CV. Hodnoťte podrobně na základě dovedností, zkušeností, vzdělání a dalších kritérií.",
    feature3Title: "Hromadné nahrávání CV",
    feature3Desc:
      "Vyhodnoťte všechny kandidáty pomocí AI — buď přesměrováním přihlášek, nebo hromadným nahráním CV.",
    feature4Title: "Export reportů",
    feature4Desc: "Stáhněte si výsledky analýzy jako PDF. Sdílejte je se svým týmem a archivujte reporty.",
    feature5Title: "Hodnocení podle kritérií pracovní nabídky",
    feature5Desc:
      "Vytvořte pomocí AI generovaná kritéria a váhy pro každou pracovní nabídku, automaticky ohodnoťte CV a rychle najděte nejvhodnější kandidáty.",
    feature6Title: "Návrhy na rozvoj",
    feature6Desc:
      "Získejte personalizované návrhy na rozvoj pro své kandidáty; zjistěte, co v jejich profilu chybí pro danou pozici. Navíc pomozte kandidátům rychle se zlepšit pomocí doporučených kurzů a zdrojů — a přiveďte je na správnou úroveň pro vaši firmu."
  },

  ats: {
    heroTitle1: "ATS",
    heroTitle2: "Systém pro sledování uchazečů",
    windowTitle: "HireThink ATS",
    heroSubtitle:
      "Shromážděte všechny přihlášky na jediné platformě, vytěžte maximum ze svého talentového poolu a automatizujte procesy po nabídce práce. Spravujte každou fázi náborového procesu z jednoho centrálního systému.",
    imageAlt: "Dashboard ATS",
    floatBadge1Title: "Talentový pool",
    floatBadge1Desc: "Chytré párování",
    floatBadge2Title: "Sledování procesu",
    floatBadge2Desc: "Automatizovaná správa",
    floatBadge3Title: "Centrální platforma",
    floatBadge3Desc: "Správa z jednoho místa",
    featuresTitle: "Funkce ATS",
    featuresSubtitle: "Výkonný ATS, který optimalizuje váš náborový proces",
    feature1Title: "Centrální správa přihlášek",
    feature1Desc:
      "Shromážděte všechny pracovní nabídky a přihlášky na jedné platformě. Snadno spravujte přihlášky z různých zdrojů.",
    feature2Title: "Talentový pool",
    feature2Desc:
      "Prohlédněte si aktuální dovednosti a zkušenosti kandidátů, kteří se hlásili na jiné pozice. Okamžitě zjistěte, zda se hodí na vaše další volné pozice, a objevte nejlepší shody pomocí AI analýzy.",
    feature3Title: "Sledování procesu",
    feature3Desc:
      "Spravujte všechny procesy po nabídce práce pro nově přijaté zaměstnance z jedné platformy. Sledujte online onboardingové dokumenty, zasílání smluv, přípravu nástupu a další administrativní kroky v jediném systému — nikdy nevynechejte žádnou fázi.",
    feature4Title: "Sledování kandidátů",
    feature4Desc:
      "Sledujte stav přihlášky, výsledky pohovorů a hodnoticí poznámky pro každého kandidáta na jednom místě.",
    feature5Title: "Spolupráce v týmu",
    feature5Desc:
      "Sdílejte poznámky se svým týmem, porovnávejte kandidáty a rozhodujte se společně.",
    feature6Title: "Integrace",
    feature6Desc:
      "Propojte se se svými stávajícími HR systémy a optimalizujte svůj pracovní postup."
  },

  assessments: {
    badgeLabel: "Psychometrická hodnocení",
    heroTitle1: "Psychometrické",
    heroTitle2: "hodnoticí centrum",
    heroSubtitle:
      "Měřte potenciál kandidátů pomocí testů osobnosti a pracovního stylu, kognitivních schopností a situačního úsudku (SJT) — poháněných AI algoritmy postavenými na celosvětově uznávaných hodnoticích principech, dodávaných během několika minut, objektivně a konzistentně.",
    windowTitle: "HireThink Psychometrické hodnocení",
    heroImageAlt: "Obrazovka psychometrického hodnocení",
    badge1Title: "Uznávaná metodologie",
    badge1Desc: "Hodnoticí principy používané po celém světě",
    badge2Title: "Vícerozměrné",
    badge2Desc: "Osobnost, kognitivní schopnosti, SJT",
    badge3Title: "Standardní proces",
    badge3Desc: "Pozvat, otestovat, reportovat, sdílet",
    sectionLabel: "Chytré moduly",
    sectionTitle: "Psychometrie a kompetence na jednom panelu",
    sectionSubtitle:
      "Kombinujte testy osobnosti a pracovního stylu, kognitivní testy a SJT s kompetenčními a případovými toky pro zrychlení náborových rozhodnutí.",
    module1Title: "Psychometrický balíček",
    module1Desc:
      "Zmapujte osobnost, hodnoty a pracovní styly pomocí moderních inventářů a doplňte je o metriky kognitivní rychlosti a pozornosti.",
    module1Bullets: [
      "Mapa osobnosti a pracovního stylu",
      "Kognitivní rychlost, pozornost, pracovní paměť",
      "Skóre sladěná s normami a prahovými hodnotami pro danou roli"
    ],
    module2Title: "Automatizace procesu",
    module2Desc:
      "AI navrhne správný balíček testů a soubor otázek podle role a úrovně; vy schválíte a jedním kliknutím odešlete pozvánky.",
    module2Bullets: [
      "Přednastavení a šablony podle role/úrovně",
      "Hromadné pozvánky a zabezpečené relace",
      "Sledování dokončení v reálném čase"
    ],
    module3Title: "Reporting a bezpečnost",
    module3Desc:
      "Psychometrické a kompetenční skóre v jednom reportu, s podrobnou analýzou a poznatky generovanými AI; ukládání v souladu s KVKK/GDPR, sdílitelné odkazy a stručná shrnutí.",
    module3Bullets: [
      "Upozornění na soulad s rolí a rizika",
      "Psychometrické shrnutí a přehledové karty",
      "Přístup v souladu s předpisy a auditní stopa"
    ],
    pillarsLabel: "Psychometrické dimenze",
    pillarsTitle: "Komplexní měření ve třech osách",
    pillarsSubtitle:
      "Každý balíček testů spojuje skóre osobnosti a pracovního stylu, kognitivních schopností a situačního úsudku (SJT) do jednoho přehledu.",
    pillar1Title: "Osobnost a pracovní styl",
    pillar1Desc:
      "Měřte pracovní hodnoty, motivaci, týmový styl a zvládání stresu pro danou roli.",
    pillar1Bullets: [
      "Škály osobnosti založené na pěti faktorech",
      "Profily vedení, orientace na zákazníka a spolupráce",
      "Signály silných stránek a rizik namapované na roli"
    ],
    pillar2Title: "Kognitivní schopnosti",
    pillar2Desc:
      "Ohodnoťte pracovní paměť, pozornost a rychlost numerického/verbálního uvažování krátkými, adaptivními testy.",
    pillar2Bullets: [
      "Časově založené skóre s rovnováhou rychlosti a přesnosti",
      "Tolerance šumu a metriky soustředění",
      "Srovnání s normou skupiny a prahovými hodnotami"
    ],
    pillar3Title: "Situační úsudek (SJT)",
    pillar3Desc:
      "Hodnoťte rozhodování, sladění s hodnotami a stanovování priorit ve skutečných pracovních scénářích.",
    pillar3Bullets: [
      "Lokalizované scénáře přizpůsobené roli",
      "Vážené skóre podle zvolených akcí",
      "Standardizovaný proces snižující zkreslení"
    ],
    flowLabel: "Průběh",
    flowTitle: "Spusťte psychometrický proces během několika minut",
    flowSubtitle:
      "Vyberte roli, schvalte AI doporučený balíček, odešlete pozvánku, získejte jeden report.",
    flow1Title: "Nastavení role a úrovně",
    flow1Desc:
      "Vyberte roli, seniority a váhu mezi kompetencemi a psychometrikou.",
    flow2Title: "Výběr balíčku",
    flow2Desc:
      "Sestavte testy osobnosti a pracovního stylu, kognitivní testy a SJT pro danou roli/úroveň; sami řídíte délku a počet otázek.",
    flow3Title: "Zabezpečená pozvánka",
    flow3Desc:
      "Pozvánky na jedno kliknutí; kontrola identity, dohled a kontroly anomálií pro transparentní relace.",
    flow4Title: "Report a sdílení",
    flow4Desc:
      "Psychometrické přehledové karty, benchmarky a doporučení pro rozvoj v jednom reportu; PDF a sdílitelný odkaz.",
    aiAdvantageLabel: "Výhoda AI",
    aiAdvantageTitle: "Proč hodnotit pomocí AI?",
    aiAdvantageSubtitle:
      "Naše algoritmy, postavené na celosvětově používaných hodnoticích principech, vyhodnocují testy mnohem rychleji, levněji a konzistentněji než tradiční metody.",
    highlight1Title: "Výsledky během minut",
    highlight1Desc:
      "AI vyhodnocuje a analyzuje testy okamžitě po dokončení — proces, který může manuálně trvat dny, zvládne za minuty.",
    highlight2Title: "Nižší náklady",
    highlight2Desc:
      "Mnohem nákladově efektivnější než externí konzultanti nebo odborní hodnotitelé — vyhodnoťte neomezený počet kandidátů podle stejného standardu.",
    highlight3Title: "Žádná lidská chyba ani zkreslení",
    highlight3Desc:
      "Standardizované algoritmické hodnocení odstraňuje chyby způsobené únavou hodnotitele, nepozorností a nevědomým zkreslením.",
    ctaLabel: "Vyžádat ukázku",
    ctaTitle: "Začněte s psychometrickým hodnocením ještě dnes",
    ctaSubtitle:
      "Spouštějte testy osobnosti a pracovního stylu, kognitivní testy a SJT z jednoho panelu se standardizovanými reporty.",
    ctaPrimary: "Vyžádat ukázku",
    ctaSecondary: "Promluvit s obchodním týmem"
  },
  training: {
    heroTitle1: "Školení",
    heroTitle2: "a onboarding zaměstnanců",
    windowTitle: "HireThink Školicí moduly",
    heroSubtitle: "Spravujte povinná školení pro své zaměstnance pomocí modulů založených na AI. Optimalizujte své školicí procesy díky sledování pokroku, testům a podrobnému reportingu.",
    imageAlt: "Dashboard školicích modulů",
    floatBadge1Title: "Povinné školení",
    floatBadge1Desc: "Zaměřeno na tým",
    floatBadge2Title: "Okamžité testy",
    floatBadge2Desc: "Hodnocení během školení",
    floatBadge3Title: "1000+ avatarů",
    floatBadge3Desc: "Různé možnosti",
    featuresTitle: "Funkce školicího modulu",
    featuresSubtitle: "Platforma školení založená na AI, která spravuje povinná školení pro vaše zaměstnance",
    feature2Title: "Personalizované školicí plány",
    feature2Desc: "Vytvořte si možnosti školení podle potřeb vaší firmy.",
    feature1Title: "1000+ možností avatarů",
    feature1Desc: "Vyberte si z bohaté knihovny avatarů. Zvolte avatara, který nejlépe odpovídá vaší firmě a tématu.",
    feature3Title: "Testy znalostí",
    feature3Desc: "Okamžitě zjistěte, zda zaměstnanci tématu rozumí, díky testům, které se objevují uprostřed videa během školení. Měřte úroveň znalostí pomocí závěrečných testů po dokončení školení.",
    feature4Title: "Sledování pokroku",
    feature4Desc: "Podrobně sledujte pokrok svých zaměstnanců ve školení. Sledujte stav dokončení, výsledky testů a míru účasti.",
    feature5Title: "Reporting",
    feature5Desc: "Analyzujte výkon zaměstnanců pomocí podrobných školicích reportů. Sledujte, jaká školení jsou dokončena, úspěšnost testů a oblasti rozvoje.",
    feature6Title: "Soustředěné učení",
    feature6Desc: "Znemožněte přeskakování školicích videí a jejich přehrávání na pozadí. Zajistěte, aby se členové vašeho týmu učili s plným soustředěním, a maximalizujte efektivitu školení.",
    coursesBadge: "Živý katalog školení",
    coursesTitle: "Naše školicí programy",
    coursesSubtitle: "Nejde o digitální moduly — jsou to skutečné firemní rozvojové programy vedené živě na naší online školicí platformě našimi odbornými lektory.",
    coursesCategory1: "HR a analytika",
    coursesCategory1Item1: "Školení HR specialisty",
    coursesCategory1Item2: "Školení HR analytiky",
    coursesCategory1Item3: "Školení Excel a AI",
    coursesCategory1Item4: "Školení Excel a AI pro HR",
    coursesCategory2: "Programy vedení a řízení",
    coursesCategory2Item1: "Rozvojový program pro vedoucí týmu",
    coursesCategory2Item2: "Rozvojový program pro vedoucí projektů a manažery",
    coursesCategory2Item3: "Stanovení priorit a plánování práce",
    coursesCategory2Item4: "Udržitelný výkon v pracovních procesech",
    coursesCategory2Item5: "Krizový management",
    coursesCategory3: "Osobní a týmový rozvoj",
    coursesCategory3Item1: "Týmové povědomí a spolupráce",
    coursesCategory3Item2: "Budování povědomí o kvalitě",
    coursesCategory3Item3: "Změna a osobní rozvoj",
    coursesCategory3Item4: "Řízení komunikace",
    coursesCategory3Item5: "Motivace a zapojení zaměstnanců",
    coursesCategory3Item6: "Dokumentace a reporting",
    coursesFootnote: "Nenašli jste školení, které hledáte? Připravíme pro vás obsah na míru.",
    coursesCta: "Zobrazit kalendář školení"
  },

  nav: {
    cvScoring: "Hodnocení CV",
    interviews: "Pohovory",
    peerInterview: "Peer pohovor",
    assessments: "Hodnocení",
    ats: "ATS",
    training: "Školení",
    pricing: "Ceník",
    contact: "Kontakt",
    login: "Přihlásit se",
    getStarted: "Přihlásit se"
  },

  nav_dropdown: {
    premiumLiveAI: "Prémiový živý AI pohovor",
    standardVideoAI: "Standardní video AI pohovor",
    voiceInterview: "Hlasový pohovor",
    textInterview: "Textový pohovor",
    whatsappInterview: "WhatsApp pohovor",
    phoneInterview: "Telefonický pohovor",
    interviewObserver: "AI pozorovatel pohovoru"
  },

  hero: {
    headline1: "Skutečný",
    headline2: "AI pohovor",
    talentHeadline1: "AI trenér",
    talentHeadline2: "přípravy na práci",
    subheadline: "Od pracovní přihlášky až po přijetí — vylepšete své procesy pomocí AI",
    talentSubheadline:
      "Trénujte realistické pohovory přizpůsobené vaší roli, získejte okamžitou analýzu, vylepšete si CV a vstupte do pohovorů s jistotou.",
    toggleHiring: "Jsem zaměstnavatel",
    toggleTalent: "Jsem kandidát",
    toggleComingSoon: "již brzy",
    heroBadge: "Poznejte nejlepší a nejkomplexnější AI HR produkt na trhu",
    ctaHiring: "Začít",
    ctaTalent: "Začít",
    talentExternalLink: "Otevřít platformu pro kandidáty",
    reviews: "recenzí",
    badge1Title: "Zaměřeno na kompetence",
    badge1Desc: "Hodnoťte na základě konkrétních kompetencí.",
    badge2Title: "Standardizované pohovory",
    badge2Desc: "Používejte stejné otázky a kritéria pro každého kandidáta.",
    badge3Title: "Založeno na datech",
    badge3Desc: "Důvěřujte poznatkům a kritériím — ne pocitům.",
    step1Title: "Vyberte balíček, který vám vyhovuje",
    step1Desc: "",
    step2Title: "Vytvořte svou pracovní nabídku",
    step2Desc: "",
    step3Title: "Nejvhodnější kandidáti jsou připraveni — s ohodnocenými CV a dokončenými pohovory!",
    step3Desc: "",
    talentOffer1Title: "Analýza CV",
    talentOffer1Desc:
      "Když nahrajete své CV, náš systém ho analyzuje a identifikuje oblasti ke zlepšení — od chybějících informací po slabé formulace, zbytečné detaily a nekonzistentní formátování. Poté poskytne jasné, personalizované návrhy, jak vaše CV učinit profesionálnějším a působivějším.",
    talentOffer2Title: "Příprava na pohovor",
    talentOffer2Desc:
      "Trénujte realistické AI pohovory přizpůsobené vaší roli a cílové firmě — video, hlasové nebo textové. Získejte okamžitou zpětnou vazbu, uvidíte příklady vylepšení slabých odpovědí, porovnejte se s průměrným skóre a vstupte do pohovorů s jistotou.",
    talentOffer3Title: "Rozvoj podle role",
    talentOffer3Desc:
      "Zjistěte své nedostatky v kompetencích pro cílovou roli díky poznatkům založeným na skóre; vybudujte si týdenní plán zlepšování s personalizovanými mikroúkoly, vybranými zdroji a cvičnými sadami — jak technickými, tak behaviorálními.",
    dashboardPreview: "Náhled dashboardu",
    totalEvaluations: "Celkem přihlášek",
    thisMonth: "tento měsíc",
    interviewCompleted: "Pohovor dokončen",
    minutesAgo: "před 5 minutami"
  },

  stats: {
    stat1Value: "24/7",
    stat1Label: "Zážitek z pohovoru",
    stat2Value: "3×",
    stat2Label: "Ušetřený čas",
    stat3Value: "97 %",
    stat3Label: "Míra konzistence"
  },

  why: {
    title: "Proč HireThink?",
    reason1Title: "Snižte náklady",
    reason1Desc: "Snižte celkové náklady tradičních pohovorových procesů až 4×.",
    reason2Title: "Zvyšte efektivitu",
    reason2Desc:
      "Rychleji oslovte ty správné kandidáty díky předvýběru založenému na AI. Zkraťte dobu do obsazení pro kvalifikované kandidáty.",
    reason3Title: "Objektivní hodnocení",
    reason3Desc: "Přijímejte nejlepší rozhodnutí díky nezaujatým, standardizovaným hodnocením."
  },

  features: {
    title: "AI řešení pro nábor",
    subtitle: "Zahajte AI optimalizaci svých HR procesů s HireThink.",
    feature1Title: "Hodnocení CV založené na AI",
    feature1Desc:
      "Shromážděte všechny přihlášky na jedné stránce, vyhodnoťte CV v různých formátech pomocí AI — přesměrováním přihlášek nebo hromadným nahráním — a ohodnoťte je podle vlastních kritérií.",
    feature2Title: "AI náborový pohovor",
    feature2Desc:
      "Proveďte pohovor se stovkami kandidátů za den pomocí virtuálního asistenta založeného na AI. Prohlédněte si výsledky během několika minut, odhalte neobvyklé situace pomocí pokročilých kontrol anomálií a projděte si záznamy pro hlubší ověření.",
    feature3Title: "Přístupné pohovory",
    feature3Desc:
      "Poskytněte plně přístupný zážitek z pohovoru kandidátům s řečovým nebo sluchovým postižením pomocí AI, která rozumí znakovému jazyku a podporuje textovou komunikaci.",
    feature4Title: "Pohovor na ověření jazykové úrovně",
    feature4Desc:
      "Získejte přístup ke globálnímu talentu díky podpoře pohovorů v turečtině, angličtině, němčině, španělštině, francouzštině, italštině a mnoha dalších jazycích — hodnoťte jazykovou úroveň podle standardizovaných, objektivních kritérií.",
    feature5Title: "Analýza kompetencí",
    feature5Desc: "Podrobné a objektivní hodnocení kandidátů napříč více než 14 sadami kompetencí, jako je komunikace, vedení a řešení problémů.",
    feature6Title: "Psychometrická hodnocení",
    feature6Desc:
      "Přijímejte přesnější a objektivnější náborová rozhodnutí měřením osobnostních a kognitivně-behaviorálních tendencí pomocí psychometrických testů.",
    feature7Title: "Školicí moduly",
    feature7Desc:
      "Identifikujte nedostatky a oblasti rozvoje kandidátů pomocí modulů založených na AI a vytvořte si své školicí plány.",
    feature8Title: "Systém pro sledování uchazečů (ATS)",
    feature8Desc:
      "Sledujte všechny kandidáty na jediné platformě a snadno spravujte celý svůj proces — od hodnocení CV až po přijetí.",
    feature9Title: "Pohovory na povýšení a případové studie",
    feature9Desc:
      "Objevte interní talenty pomocí hodnocení povýšení a případových studií založených na AI.",
    feature10Title: "AI systém doporučování kandidátů",
    feature10Desc:
      "Neomezujte se pouze na uchazeče — objevte nejvhodnější kandidáty pro svou pracovní nabídku a odesílejte nabídky pomocí AI.",
    feature11Title: "Modul stížností a návrhů",
    feature11Desc:
      "Neustále zlepšujte HR procesy shromažďováním strukturované zpětné vazby od zaměstnanců i zákazníků.",
    feature12Title: "AI výstupní pohovory",
    feature12Desc:
      "Pochopte zkušenost zaměstnanců, shromážděte cennou zpětnou vazbu a podpořte organizační zlepšení."
  },

  howItWorks: {
    title: "Jak to funguje",
    subtitle: "Optimalizujte svůj náborový proces během několika minut",
    cvScoringTitle: "Modul hodnocení CV",
    cvStep1Title: "Zveřejněte svou pracovní nabídku",
    cvStep1Desc:
      "Přesměrujte svou aktuální pracovní nabídku na přihlašovací stránku HireThink nebo hodnoťte kandidáty pomocí AI hromadným nahráním CV.",
    cvStep2Title: "Prohlédněte si hodnocení CV",
    cvStep2Desc: "Zobrazte si skóre CV příchozích přihlášek během několika sekund.",
    cvStep3Title: "Odešlete pozvánky na pohovor",
    cvStep3Desc: "Odešlete hromadné pozvánky na pohovor vybraným kandidátům.",
    interviewTitle: "AI pohovor",
    intStep1Title: "Vytvořte svůj pohovor",
    intStep1Desc:
      "Definujte soubor otázek, kompetence, otázky, časové rozmezí a další nastavení pomocí AI — a nakonfigurujte průběh pohovoru.",
    intStep2Title: "Odešlete hromadné pozvánky",
    intStep2Desc:
      "Pozvěte kandidáty jedním kliknutím z hodnocení CV nebo jiných systémů, nebo importujte kandidáty přes Excel a odešlete pozvánky.",
    intStep3Title: "Prohlédněte si analýzy",
    intStep3Desc:
      "Prohlédněte si skóre a analýzy dokončených pohovorů z dashboardu, porovnejte kandidáty a exportujte výsledky."
  },

  competencies: {
    title: "Sady kompetencí",
    subtitle: "Vyberte správné kompetence pro svou roli a oslovte ty správné kandidáty pomocí analýzy kompetencí.",
    communication: "Komunikační dovednosti",
    teamwork: "Týmová práce",
    problemSolving: "Řešení problémů",
    decisionMaking: "Rozhodování",
    leadership: "Vedení",
    adaptability: "Adaptabilita / flexibilita",
    responsibility: "Vlastní odpovědnost",
    planning: "Plánování a organizace",
    goalOrientation: "Orientace na cíl",
    personalDevelopment: "Osobní rozvoj",
    customerFocus: "Orientace na zákazníka",
    analyticalThinking: "Analytické myšlení",
    innovation: "Inovace",
    ethics: "Etika a orientace na hodnoty",
    languagesTitle: "Podpora více jazyků",
    languagesSubtitle: "Vytvářejte pohovory v různých jazycích a získejte přístup ke globálnímu talentu.",
    turkish: "Turečtina",
    english: "Angličtina",
    german: "Němčina",
    french: "Francouzština",
    spanish: "Španělština",
    italian: "Italština",
    portuguese: "Portugalština",
    dutch: "Nizozemština",
    polish: "Polština",
    czech: "Čeština",
    swedish: "Švédština",
    norwegian: "Norština",
    danish: "Dánština",
    romanian: "Rumunština",
    hungarian: "Maďarština",
    finnish: "Finština",
    croatian: "Chorvatština",
    slovenian: "Slovinština",
    slovak: "Slovenština",
    catalan: "Katalánština",
    estonian: "Estonština",
    latvian: "Lotyština",
    lithuanian: "Litevština",
    albanian: "Albánština",
    bosnian: "Bosenština",
    macedonian: "Makedonština",
    maltese: "Maltština",
    luxembourgish: "Lucemburština",
    afrikaans: "Afrikánština",
    azerbaijani: "Ázerbájdžánština",
    indonesian: "Indonéština",
    malay: "Malajština",
    maori: "Maorština",
    tagalog: "Tagalog",
    vietnamese: "Vietnamština",
    languagesNote:
      "Díky naší infrastruktuře založené na AI podporujeme více než 30 jazyků. Naši AI můžete okamžitě natrénovat z administračního panelu pro slova, jejichž výslovnost se vám nelíbí.",
    moreLanguagesChip: "+ Další jazyky",
    imageAlt: "Vizualizace sad kompetencí",
    analysisTitle: "Flexibilní konfigurace analýzy",
    qaAnalysis: "Analýza otázek a odpovědí",
    talentAnalysis: "Analýza kompetencí",
    analysisNote:
      "Díky flexibilní konfiguraci analýzy můžete nastavit různé váhy kompetencí pro studentské programy a nábor na seniorní pozice."
  },

  integrations: {
    title: "Integrujte se svými oblíbenými nástroji",
    subtitle: "Snadno se integrujte do svých stávajících pracovních postupů a zvyšte produktivitu.",
    seeAll: "Zobrazit všechny integrace"
  },

  testimonials: {
    title: "Rychlé. Spolehlivé. Cenově dostupné.",
    subtitle: "Co říkají naši zákazníci",
    quote1:
      "S HireThink jsme zrychlili naše pohovorové procesy o 60 %. Nyní dokážeme mnohem rychleji oslovit ty správné kandidáty.",
    author1: "Ayşe Yılmaz",
    role1: "HR ředitelka",
    company1: "TechCorp",
    quote2:
      "Hodnocení založená na AI poskytují nezaujaté a konzistentní výsledky. Pomáhá nám to přijímat nejlepší rozhodnutí.",
    author2: "Mehmet Kaya",
    role2: "Manažer náboru",
    company2: "FinanceHub",
    quote3:
      "Používání je neuvěřitelně snadné a reporty jsou velmi podrobné. Celý náš tým je velmi spokojený.",
    author3: "Zeynep Demir",
    role3: "HR manažerka",
    company3: "StartupX",
    trustedBy: "Důvěřují nám"
  },

  cta: {
    headline1: "Jste připraveni",
    headline2: "proměnit",
    headline3: "svůj náborový proces?",
    subtitle: "Začněte používat HireThink ještě dnes a objevte budoucnost náboru.",
    button: "Začít",
    orContact: "nebo nás kontaktujte →"
  },

  footer: {
    email: "info@hirethink.ai",
    description: "Optimalizujte své náborové procesy pomocí řešení pro pohovory založených na AI.",
    kvkkCompliant: "V souladu s KVKK",
    iso27001: "ISO 27001",
    about: "O nás",
    pricing: "Ceník",
    blog: "Blog",
    careers: "Kariéra",
    contact: "Kontakt",
    faq: "Časté dotazy",
    newsletter: "Newsletter",
    solutions: "Řešení",
    premiumInterview: "Prémiový živý AI pohovor",
    standardInterview: "Standardní video AI pohovor",
    voiceInterview: "Hlasový AI pohovor",
    textInterview: "Textový AI pohovor",
    peerInterview: "Peer pohovor",
    whatsappInterview: "WhatsApp AI pohovor",
    phoneInterview: "Telefonický AI pohovor",
    interviewObserver: "AI pozorovatel pohovoru",
    cvScoring: "Hodnocení CV",
    videoInterview: "Video pohovor",
    avatarInterview: "AI Avatar pohovor",
    cvAnalysis: "Analýza CV",
    interviewPrep: "Příprava na pohovor",
    roleGrowth: "Rozvoj podle role",
    legal: "Právní informace",
    terms: "Podmínky použití",
    privacy: "Zásady ochrany osobních údajů",
    kvkk: "KVKK",
    cookies: "Zásady cookies",
    distanceSales: "Smlouva o prodeji na dálku",
    deliveryReturn: "Podmínky doručení a vrácení",
    copyright: "© 2025 HireThink Artificial Intelligence Technologies Inc. Všechna práva vyhrazena.",
    address: "Bilişim Vadisi, Ayazağa, Vadi Istanbul Park Etabı, Kemerburgaz Caddesi D:7A Blok, 34475 Sarıyer/İstanbul",
    youtube: "YouTube",
    linkedin: "LinkedIn",
    emailLabel: "E-mail"
  },

  contact: {
    title: "Kontaktujte nás",
    subtitle: "Ozveme se vám co nejdříve",
    pageTitle: "Kontakt",
    pageSubtitle: "Ozvěte se nám s dotazy, návrhy nebo možnostmi spolupráce.",
    infoTitle: "Kontaktní informace",
    formTitle: "Kontaktní formulář",
    formDescription: "Klikněte na tlačítko níže a otevřete kontaktní formulář pro odeslání zprávy.",
    openForm: "Otevřít kontaktní formulář",
    email: "E-mail",
    phone: "Telefon",
    address: "Adresa",
    fullAddress:
      "Bilişim Vadisi, Ayazağa, Vadi Istanbul Park Etabı, Kemerburgaz Caddesi D:7A Blok, 34475 Sarıyer/İstanbul",
    vkn: "Daňové identifikační číslo",
    companyName: "Společnost",
    fullName: "Celé jméno",
    fullNamePlaceholder: "Vaše celé jméno",
    emailPlaceholder: "priklad@email.com",
    phonePlaceholder: "+420 555 123 456",
    employeeCount: "Počet zaměstnanců",
    employeeCountPlaceholder: "Vyberte počet zaměstnanců",
    submit: "Odeslat",
    submitting: "Odesílání...",
    successTitle: "Úspěch!",
    successMessage: "Vaše zpráva byla přijata. Brzy vás budeme kontaktovat.",
    appointmentDescription: "Pomocí naší kalendářové stránky si můžete rezervovat schůzku nebo naplánovat setkání.",
    appointmentCta: "Rezervovat schůzku"
  },
  calendar: {
    pageTitle: "Kalendář",
    pageSubtitle: "Vyberte časové rozmezí pro vytvoření schůzky.",
    prev: "Předchozí",
    next: "Další",
    today: "Dnes",
    day: "Den",
    week: "Týden",
    month: "Měsíc",
    refresh: "Obnovit",
    loading: "Načítání kalendáře...",
    loadError: "Data kalendáře se nepodařilo načíst.",
    createTitle: "Vytvořit schůzku",
    createSubtitle: "Vyberte časové rozmezí v kalendáři pro otevření formuláře.",
    openCreate: "Otevřít novou schůzku",
    formTitle: "Nová schůzka",
    formSubtitle: "Vyplňte údaje pro vybrané časové rozmezí.",
    customerName: "Celé jméno",
    customerEmail: "E-mail",
    customerPhone: "Telefon",
    startTime: "Čas začátku",
    endTime: "Čas konce",
    duration: "Délka trvání (min)",
    notes: "Poznámky",
    cancel: "Zrušit",
    submit: "Uložit",
    submitting: "Ukládání...",
    createError: "Schůzku se nepodařilo vytvořit.",
    emptySelection: "Vyberte platné časové rozmezí.",
    halfHourError: "Časy musí být v 30minutových intervalech.",
    durationFixedError: "Všechny schůzky trvají 30 minut.",
    durationFixedValue: "30 min",
    emailError: "Zadejte platnou e-mailovou adresu.",
    phoneError: "Zadejte platné telefonní číslo.",
    phoneCountry: "Předvolba země",
    phoneCountryTR: "Turecko (+90)",
    phoneCountryUS: "Spojené státy (+1)",
    phoneCountryGB: "Spojené království (+44)",
    phoneCountryDE: "Německo (+49)",
    detailsTitle: "Detaily schůzky",
    noSelection: "Vyberte schůzku pro zobrazení podrobností.",
    status: "Stav",
    statusUnknown: "Neznámý",
    unknownCustomer: "Kandidát",
    instructionsTitle: "Jak to funguje",
    instructionsText: "Klikněte na datum a čas, který chcete rezervovat, nebo tažením vyberte časové rozmezí. Formulář se otevře automaticky.",
    instructionsNote: "Možnosti délky trvání jsou omezeny na 30 a 60 minut.",
    apiAlertTitle: "Upozornění",
    close: "Zavřít"
  },
  pricing: {
    title: "Ceník",
    subtitle: "Vyberte plán, který odpovídá velikosti vaší firmy, a optimalizujte svůj náborový proces.",
    monthlyPayment: "Měsíční fakturace",
    yearlyPayment: "Roční fakturace",
    savePercent: "(sleva 25 %)",
    yearlyTotal: "Roční celkem",
    starterName: "Starter",
    starterDesc: "Ideální pro malé firmy a základní náborové potřeby.",
    starterCta: "Začít",
    professionalName: "Professional",
    professionalDesc: "Komplexní řešení pro rostoucí firmy s vysokým objemem náboru.",
    professionalCta: "Začít",
    professionalPopular: "Nejoblíbenější",
    enterpriseName: "Ultimate",
    enterpriseDesc: "Řešení na míru pro potřeby vašeho týmu nebo neomezené používání.",
    enterpriseCta: "Kontaktujte nás",
    custom: "Na míru",
    starterFeature1: "15 AI pohovorů s avatarem nebo 50 AI pohovorů",
    starterFeature2: "500 hodnocení CV",
    starterFeature3: "2 uživatelské účty",
    starterFeature4: "Neomezené pracovní nabídky",
    starterFeature5: "Neomezené vytváření otázek",
    starterFeature6: "Reporting kompetencí",
    starterFeature7: "Reporty anomálií",
    starterFeature8: "Pokročilá analytika",
    starterFeature9: "Průměrné výsledky kandidátů",
    starterFeature10: "Sady kompetencí",
    starterFeature11: "Peer pohovor",
    starterFeature12: "ATS",
    starterFeature13: "Psychometrická hodnocení",
    starterFeature14: "Standardní podpora",
    starterFeature15: "Onboarding a modul interního školení",
    starterFeature16: "Správa stížností a spokojenosti",
    starterFeature17: "Telefonický pohovor",
    starterFeature18: "AI kontrola referencí",
    textInterview300: "300 textových pohovorů",
    whatsappInterview: "WhatsApp pohovor",
    aiCandidateSearch: "AI vyhledávání kandidátů",
    aiOfferSuggestion: "AI doporučení mzdové nabídky",
    professionalFeature1: "300 AI pohovorů s avatarem nebo 600 AI pohovorů",
    professionalFeature2: "8 000 hodnocení CV",
    professionalFeature3: "8 uživatelských účtů",
    professionalFeature4: "Neomezené pracovní nabídky",
    professionalFeature5: "Neomezené vytváření otázek",
    professionalFeature6: "Reporting kompetencí",
    professionalFeature7: "Reporty anomálií",
    professionalFeature8: "Pokročilá analytika",
    professionalFeature9: "Průměrné výsledky kandidátů",
    professionalFeature10: "Sady kompetencí",
    professionalFeature11: "Peer pohovor",
    professionalFeature12: "ATS",
    professionalFeature13: "Reporty o uzavření pozic",
    professionalFeature14: "Psychometrická hodnocení",
    professionalFeature15: "Prioritní podpora",
    professionalFeature16: "Onboarding a modul interního školení",
    professionalFeature17: "Správa stížností a spokojenosti",
    professionalFeature18: "Telefonický pohovor",
    professionalFeature19: "AI kontrola referencí",
    enterpriseFeature1: "Řešení přizpůsobená vašim potřebám",
    enterpriseFeature2: "Vyhrazený account manažer",
    enterpriseFeature3: "Reporting na míru",
    enterpriseFeature4: "Psychometrická hodnocení",
    enterpriseFeature5: "Prioritní podpora 24/7",
    enterpriseFeature6: "Školení a onboarding na míru",
    enterpriseFeature7: "Integrace na míru",
    enterpriseFeature8: "LLM řešení na míru firmě",
    enterpriseFeature9: "Správa stížností a spokojenosti založená na AI",
    enterpriseFeature10: "Onboarding a modul interního školení",
    enterpriseFeature11: "Telefonický pohovor",
    enterpriseFeature12: "AI kontrola referencí",
    perMonth: "/měsíc"
  },

  talentProducts: {
    title: "Produkty pro kandidáty",
    subtitle:
      "Tři klíčové kroky založené na AI pro vaše hledání práce: analyzovat, trénovat, zlepšovat. Každý je personalizován pro vaši roli a přináší měřitelnou zpětnou vazbu.",

    freeCvBadge: "100% zdarma",
    freeCvTitle: "Vytvořte si profesionální CV s AI — zdarma",
    freeCvDesc:
      "Nepište si CV od začátku. Zadejte své údaje a nechte AI vytvořit profesionální CV vhodné pro ATS ve formátu, který náboráři hledají. Bez nutnosti platební karty, stáhněte si ho během několika minut.",
    freeCvPoint1: "Hotové CV během několika minut",
    freeCvPoint2: "Profesionální šablony vhodné pro ATS",
    freeCvPoint3: "Návrhy formulací poháněné AI",
    freeCvCta: "Vytvořit CV zdarma",
    freeCvHint: "Vytvořte si ho zdarma na isbulsun.com",

    cvAnalysisBadge: "AI analýza CV",
    cvAnalysisTitle: "Analýza CV",
    cvAnalysisDesc:
      "Naskenujte své CV pomocí AI; získejte samostatná skóre pro kompatibilitu s ATS, čitelnost, sílu dopadu a soulad s rolí.",
    cvAnalysisDescLong:
      "Nahrajte své CV do našeho analytického enginu založeného na AI a získejte komplexní hodnoticí report během několika sekund. Podrobně si prohlédněte svou čitelnost pro ATS, soulad s oborovými standardy, formulace zaměřené na dopad a míru shody s vaší cílovou rolí. Zjistěte, v čem vynikají konkurenční kandidáti, získejte AI návrhy vět pro chybějící části a přetvořte své CV do formátu, který náboráři chtějí vidět.",
    cvFeature1Title: "Skóre kompatibility s ATS",
    cvFeature1Desc: "Zjistěte, jak automatizované systémy pro třídění vidí vaše CV.",
    cvFeature2Title: "Srovnání s oborem",
    cvFeature2Desc: "Porovnejte své CV s kandidáty na podobné pozice.",
    cvFeature3Title: "Chytré návrhy",
    cvFeature3Desc: "Získejte konkrétní návrhy na zlepšení pro každou část.",
    cvFeature4Title: "Metriky úspěchů",
    cvFeature4Desc: "Učiňte své úspěchy měřitelnými pomocí formulací zaměřených na dopad.",
    cvCheck1: "Návrhy na zlepšení po jednotlivých řádcích",
    cvCheck2: "Analýza čitelnosti a formátu",
    cvCheck3: "Optimalizace klíčových slov",
    cvMockTitle: "Report analýzy CV",
    cvMockSubtitle: "Pozice Softwarový inženýr",
    cvMockScore: "Celkové skóre",
    cvScoreATS: "Kompatibilita s ATS",
    cvScoreImpact: "Síla dopadu",
    cvScoreReadability: "Čitelnost",
    cvScoreRole: "Soulad s rolí",
    cvSuggestionTitle: "Návrh AI",
    cvSuggestionText:
      "„Řídil jsem projekty“ → Přidejte konkrétní metriky, například „Vedl jsem 5členný tým a dodal jsem projekt, který za 3 měsíce zvýšil efektivitu o 40 %.“",
    cvFloatLabel: "Nárůst míry konverze",
    cvFloatAI: "Analýza založená na AI",

    interviewPrepBadge: "AI trénink pohovorů",
    interviewPrepTitle: "Příprava na pohovor",
    interviewPrepDesc: "Trénujte s dynamickými soubory otázek založenými na skutečných pracovních scénářích.",
    interviewPrepDescLong:
      "Připravte se pomocí simulací pohovorů přizpůsobených vaší cílové pozici a profilu firmy. Zažijte skutečný pohovor ve video, hlasovém nebo textovém režimu. AI poskytuje okamžitou zpětnou vazbu: vyhodnocuje strukturu vaší odpovědi a kvalitu obsahu. Porovnejte svůj výkon s průměrným skóre kandidátů, získejte podrobné hodnocení technické přesnosti a srozumitelnosti komunikace a posilte svou sebedůvěru díky alternativním ukázkovým odpovědím a návrhům na zlepšení pro každou slabou odpověď.",
    interviewFeature1Title: "Více režimů pohovoru",
    interviewFeature1Desc: "Trénujte ve video, hlasovém nebo textovém formátu.",
    interviewFeature2Title: "Okamžitá AI analýza",
    interviewFeature2Desc: "Vaše odpovědi jsou hodnoceny v reálném čase.",
    interviewFeature3Title: "Ukázkové odpovědi",
    interviewFeature3Desc: "Prohlédněte si alternativní ideální odpovědi pro každou otázku.",
    interviewFeature4Title: "Srovnání s ostatními kandidáty",
    interviewFeature4Desc: "Porovnejte svůj výkon s ostatními kandidáty.",
    interviewCheck1: "Soubory otázek pro více než 150 rolí",
    interviewCheck2: "Srovnání výkonu s průměrným skóre",
    interviewCheck3: "Scénáře pohovorů specifické pro daný obor",
    interviewRecording: "Nahrávání",
    interviewQuestion: "Mohli byste nám říct něco o sobě a svých kariérních cílech?",
    interviewModeVideo: "Video",
    interviewModeVoice: "Hlas",
    interviewModeText: "Text",
    interviewFeedbackTitle: "Okamžité hodnocení",
    interviewScoreClarity: "Srozumitelnost",
    interviewScoreStructure: "Struktura",
    interviewScoreConfidence: "Sebedůvěra",
    interviewFloatInstant: "Okamžitá zpětná vazba",
    interviewFloatQuestions: "Banka otázek",

    roleGrowthBadge: "Kariérní růst",
    roleGrowthTitle: "Rozvoj podle role",
    roleGrowthDesc: "Zjistěte své nedostatky v kompetencích na základě cílové role.",
    roleGrowthDescLong:
      "Jasně si prohlédněte kompetence potřebné k dosažení vašeho kariérního cíle. AI porovná vaše aktuální dovednosti s požadavky cílové role a vytvoří personalizovanou rozvojovou mapu. Postupujte systematicky pomocí týdenních mikroúkolů, vybraných zdrojů, cvičných sad a mini hodnocení. Uzavřete mezery v technických i behaviorálních kompetencích a zároveň posilte své stávající silné stránky.",
    growthFeature1Title: "Mapa kompetencí",
    growthFeature1Desc: "Vizualizujte své silné stránky a oblasti ke zlepšení.",
    growthFeature2Title: "Vybrané zdroje",
    growthFeature2Desc: "Školicí obsah a články sladěné s vaším cílem.",
    growthFeature3Title: "Mikroúkoly",
    growthFeature3Desc: "Budujte neustálé zlepšování pomocí denní praxe.",
    growthFeature4Title: "Sledování pokroku",
    growthFeature4Desc: "Sledujte svůj růst pomocí měřitelných metrik.",
    growthCheck1: "Personalizovaná studijní cesta",
    growthCheck2: "Týdenní reporty o pokroku",
    growthCheck3: "Srovnání s oborovým benchmarkem",
    growthMockTitle: "Dashboard rozvoje",
    growthMockSubtitle: "Cíl: Product Manager",
    skillTechnical: "Technické znalosti",
    skillCommunication: "Komunikace",
    skillLeadership: "Vedení",
    skillProblem: "Řešení problémů",
    skillAdaptability: "Adaptabilita",
    skillTeamwork: "Týmová práce",
    weeklyTasksTitle: "Úkoly tohoto týdne",
    task1: "Přečtěte si článek o efektivních odpovědích na pohovoru",
    task2: "Procvičte si 2 behaviorální otázky",
    task3: "Dokončete případovou studii o vedení",
    growthFloatProgress: "Týdenní pokrok",
    growthFloatResources: "50+ zdrojů"
  },

  blog: {
    title: "Blog",
    subtitle: "Aktuální obsah o AI, náboru a lidských zdrojích",
    post1Title: "Proměna náborových procesů pomocí AI",
    post1Excerpt: "Objevte, jak AI technologie revolucionizují moderní náborové procesy.",
    post2Title: "Hodnocení CV: nový způsob, jak najít správného kandidáta",
    post2Excerpt: "Vyhodnoťte tisíce přihlášek během několika minut pomocí systémů hodnocení CV založených na AI.",
    post3Title: "Budoucnost technologií pohovorů",
    post3Excerpt: "Prozkoumejte, jak video, hlasové a textové AI pohovory přispívají k náborovým procesům.",
    categoryAI: "Umělá inteligence",
    categoryHR: "Lidské zdroje",
    categoryTechnology: "Technologie",
    readMore: "Číst dál",
    comingSoon: "Brzy přibude další obsah. Zůstaňte s námi!"
  },

  career: {
    title: "Kariéra",
    subtitle: "Připojte se k týmu HireThink a společně utvářejte budoucnost AI technologií",
    noOpeningsTitle: "Momentálně nejsou k dispozici žádné volné pozice",
    noOpeningsDesc:
      "Aktuálně nemáme žádné aktivní pracovní nabídky. Můžete nás však sledovat kvůli budoucím pozicím nebo nám zaslat své CV.",
    stayTuned: "Zůstaňte s námi",
    valuesTitle: "Naše hodnoty",
    value1Title: "Týmová práce",
    value1Desc: "Budujeme silnější řešení díky společné práci.",
    value2Title: "Inovace",
    value2Desc: "Přinášíme inovativní řešení díky kultuře neustálého učení a růstu.",
    value3Title: "Excelence",
    value3Desc: "Usilujeme o nejvyšší standardy kvality v každém projektu.",
    linkedinText: "Sledujte naši stránku na LinkedIn, abyste měli přehled o volných pozicích",
    followLinkedIn: "Sledovat na LinkedIn",
    aiBadge: "NOVINKA • Hledání práce poháněné AI",
    aiTitle1: "Najděte si vysněnou práci",
    aiTitle2: "s AI",
    aiSubtitle: "Popište práci, kterou hledáte, běžným jazykem. AI okamžitě seřadí nejvhodnější pozice pro vás.",
    aiPlaceholder: "Např.: Hledám pozici React vývojáře v Praze s hybridní prací, s praxí 3 a více let...",
    aiButton: "Hledat pomocí AI",
    aiSearching: "AI analyzuje pracovní nabídky...",
    aiResultsCount: "nalezených pozic",
    aiNoResults: "Vašemu hledání neodpovídají žádné nabídky. Zkuste jiná klíčová slova.",
    aiClear: "Vymazat",
    aiExampleLabel: "Zkuste:",
    aiExample1: "React vývojář na dálku",
    aiExample2: "Hybridní AI/ML inženýr",
    aiExample3: "Product Manager v Praze",
    aiExample4: "UI/UX designér na dálku",
    aiInputLabel: "Hledání práce",
    openingsTitle: "Volné pozice",
    openingsCount: "otevřených nabídek",
    jobViewDetail: "Zobrazit podrobnosti",
    jobNotFound: "Nabídka nenalezena",
    jobNotFoundDesc: "Hledaná pracovní nabídka neexistuje nebo mohla být odstraněna.",
    detailBack: "Zpět na nabídky",
    detailShare: "Sdílet",
    detailApply: "Podat přihlášku",
    detailAbout: "O pozici",
    detailResponsibilities: "Odpovědnosti",
    detailRequirements: "Požadavky",
    detailBenefits: "Benefity",
    detailInfo: "Podrobnosti o pozici",
    detailLocation: "Lokalita",
    detailWorkType: "Model práce",
    detailDepartment: "Oddělení",
    detailExperience: "Zkušenosti",
    detailSalary: "Mzdové rozmezí",
    detailPosted: "Zveřejněno:",
    detailDeadline: "Uzávěrka:",
    detailApplyTitle: "Připraveni podat přihlášku na tuto pozici?",
    detailApplySubtitle: "Získejte rychlou odpověď díky náborovému procesu HireThink poháněnému AI. Odešlete svou přihlášku přes naši kontaktní stránku.",
    simTitle: "Ověřte si, zda se hodíte na tuto roli",
    simSubtitle: "Spusťte simulaci pohovoru specifickou pro danou pozici s AI HR asistentem HireThink. Okamžitě objevte své silné stránky a oblasti rozvoje.",
    simButton: "Spustit AI simulaci",
    simNote: "Výsledky simulace jsou soukromé, pouze pro vás. Žádná data nejsou sdílena s náboráři."
  },
  faq: {
    title: "Často kladené otázky",
    subtitle: "Časté dotazy ohledně HireThink",
    items: [
      {
        question: "Co je HireThink?",
        answer:
          "HireThink je náborová a pohovorová platforma poháněná AI. Nabízí hodnocení CV, živé AI Avatar pohovory, asynchronní video pohovory, hlasové AI pohovory, textové AI pohovory, hodnocení kompetencí a osobnosti, peer pohovory, systém pro sledování uchazečů (ATS) a školicí moduly — vše na jedné platformě. Zrychluje nábor v průměru o 70 % a zkracuje dobu prověřování CV o 80 %."
      },
      {
        question: "Jak funguje AI pohovor?",
        answer:
          "Po vytvoření pracovní nabídky kandidáti automaticky obdrží odkaz na pohovor e-mailem. Připojují se přes prohlížeč nebo telefon — bez nutnosti stahování aplikace. AI analyzuje obsah, tón, plynulost a signály kompetencí buď v reálném čase, nebo během několika minut po dokončení pohovoru a generuje strukturovaný report kompetencí."
      },
      {
        question: "Je HireThink v souladu s KVKK a GDPR?",
        answer:
          "Ano. HireThink je plně v souladu jak s tureckým zákonem o ochraně osobních údajů (KVKK), tak s obecným nařízením EU o ochraně osobních údajů (GDPR). Soulad s KVKK je klíčovým principem návrhu — nikoli dodatečnou funkcí. Všechny záznamy pohovorů jsou uloženy šifrovaně na zabezpečených serverech. Zásady zpracování a uchovávání dat jsou transparentně zveřejněny."
      },
      {
        question: "Pro jaká odvětví je HireThink nejvhodnější?",
        answer:
          "HireThink je vhodný pro technologie, finance, maloobchod, logistiku, zdravotnictví, call centra, výrobu a jakoukoli organizaci s častým nebo vysokoobjemovým náborem. Je obzvláště efektivní pro hromadný nábor, vzdálený nábor a období rychlého škálování. Jako lokálně vybudovaná platforma splňuje specifické požadavky (KVKK, turecké pracovní právo, podpora tureckého jazyka), které globálním alternativám často chybí."
      },
      {
        question: "Může se HireThink integrovat s mým stávajícím HR softwarem?",
        answer:
          "Ano. HireThink podporuje API integraci se stávajícími HR a ERP systémy, jako jsou Kolay İK, Logo HR a SAP SuccessFactors. Přihlášky z Kariyer.net, LinkedIn a Indeed lze importovat do ATS. Podporovány jsou také integrace s Google Calendar a Outlook Calendar. Pro podrobné informace o integraci kontaktujte info@hirethink.ai."
      },
      {
        question: "Jaký je rozdíl mezi prémiovým živým AI pohovorem a standardním video pohovorem?",
        answer:
          "Prémiový živý AI Avatar pohovor je relace v reálném čase a interaktivní: AI avatar mluví s kandidátem živě a poskytuje okamžitou analýzu kompetencí. Standardní video AI pohovor je asynchronní: kandidát nahrává odpovědi vlastním tempem a AI je vyhodnotí následně. Živé pohovory poskytují hlubší hodnocení kompetencí; standardní pohovory se škálují bez nutnosti koordinace plánování."
      },
      {
        question: "Zvládne HireThink vysokoobjemový nábor?",
        answer:
          "Ano. Díky hromadnému nahrávání kandidátů přes Excel, automatizovanému odesílání pozvánek a podpoře souběžných relací je HireThink navržen přímo pro vysokoobjemový nábor. Modul hodnocení CV seřadí stovky přihlášek během sekund a automaticky vytvoří užší výběr."
      },
      {
        question: "Jaké AI modely HireThink používá?",
        answer:
          "HireThink běží na multimodelové AI infrastruktuře, která pro každý úkol vybírá nejvhodnější model. Hlas avataru je poskytován pokročilou technologií syntézy řeči ve více než 30 jazycích."
      },
      {
        question: "Jaký je ceník HireThink?",
        answer:
          "Ceny se liší podle velikosti firmy, potřeb použití a zvolených modulů. K dispozici jsou možnosti měsíční a roční fakturace. Vyžádejte si podrobný ceník: info@hirethink.ai nebo +90 850 307 80 61."
      },
      {
        question: "Mohu si vyžádat ukázku?",
        answer:
          "Ano. Vyžádejte si ukázku přes info@hirethink.ai nebo prostřednictvím kontaktního formuláře na našem webu. Náš tým se vám brzy ozve."
      },
      {
        question: "Jak dlouhý je čas na odpověď?",
        answer:
          "Čas na odpověď závisí na délce, kterou zvolíte při vytváření pohovoru. Několik sekund před koncem časovače se zobrazí vizuální upozornění a kandidát má za úkol dokončit odpověď v tomto čase. Odpovědi odeslané po uplynutí časového limitu se nepovažují za platné."
      },
      {
        question: "Kdy se může kandidát pohovoru zúčastnit?",
        answer:
          "Jakmile odešlete pozvánku na pohovor, kandidát obdrží e-mail s přístupovým odkazem. Kandidát se může připojit kdykoli během platnosti pozvánky."
      },
      {
        question: "Jak dlouho trvá kandidátovi dokončit odeslaný video pohovor?",
        answer:
          "To zcela závisí na vašem nastavení pohovoru. Můžete definovat počáteční a koncové časové okno. Po vypršení časového okna se pozvánka stane neplatnou."
      },
      {
        question: "Co se stane, pokud kandidát nedokončí video pohovor ve stanoveném čase?",
        answer:
          "Pokud kandidát opustí nedokončený pohovor a pohovor je stále v rámci aktivního časového okna, může se přihlásit stejným odkazem a pokračovat tam, kde skončil. Toto vám bude nahlášeno v reportech anomálií. Pokud vaše časové okno již vypršelo, pozvánka se stane neplatnou."
      },
      {
        question: "Pokud kandidát zavře pohovor před jeho dokončením, může pokračovat tam, kde skončil?",
        answer:
          "Ano. Pokud je pohovor stále aktivní, kandidát se může znovu přihlásit stejným odkazem a pokračovat tam, kde skončil. Budete o tom informováni prostřednictvím detekce anomálií / reportů anomálií."
      },
      {
        question: "Existují ukázkové otázky, které mohu kandidátovi položit?",
        answer:
          "Ano. Můžete vybírat otázky z naší banky otázek, která obsahuje jak obecné, tak odborné otázky. Pro specifičtější otázky podle role můžete otázky generovat pomocí AI při vytváření pohovoru."
      },
      {
        question: "Jak mohu kandidáty pozvat na pohovor?",
        answer:
          "Kandidáty můžete pozvat 3 způsoby: (1) přidat je jednotlivě pomocí tlačítka „Pozvat kandidáty“, (2) hromadně nahrát přes soubor Excel, nebo (3) použít přesměrování z pracovní nabídky (přesměrování přihlášky)."
      },
      {
        question: "Proč byly pohovory odeslány pouze některým kandidátům, kterým jsem chtěl odeslat?",
        answer:
          "Pozvánky nelze odeslat kandidátům s chybějícími nebo neplatnými informacemi (např. neplatná e-mailová adresa). Systém vám to nahlásí."
      },
      {
        question: "Jak mohu zkontrolovat stav dokončení odeslaných pohovorů?",
        answer:
          "Existuje více způsobů: nedávnou aktivitu kandidátů můžete sledovat na dashboardu, nebo přejít na stránku podrobností pracovní nabídky, kde uvidíte stavy všech kandidátů a seznam si můžete filtrovat podle stavu."
      },
      {
        question: "Jak mohu spravovat proces hodnocení kandidátů v HireThink?",
        answer:
          "Při procházení dokončených pohovorů si můžete zaznamenávat poznámky do pole HR poznámky. Můžete si také prohlédnout ostatní HR poznámky v rámci vaší firmy a porovnávat kandidáty prostřednictvím našeho ATS systému."
      },
      {
        question: "Mohu získat výsledky pohovoru v souboru Excel?",
        answer:
          "Ano. Výsledky si můžete snadno stáhnout jako soubor Excel kliknutím na tlačítko „Exportovat Excel“."
      },
      {
        question: "Mohu vyhledávat/filtrovat kandidáty podle jména, příjmení a e-mailové adresy?",
        answer:
          "Ano. Kandidáty lze vyhledávat napříč odeslanými pohovory podle jména, příjmení, e-mailu a mnoha dalších metrik."
      },
      {
        question: "Jak mohu aktivovat pasivní pohovor?",
        answer:
          "Pro aktivaci pasivního pohovoru otevřete „Upravit pohovor“ a změňte jeho stav na „Aktivní“."
      },
      {
        question: "Jak mohu upravit dříve vytvořený video pohovor?",
        answer:
          "Vyberte pohovor, který chcete aktualizovat, a použijte možnost „Upravit“ / „Upravit pohovor“ pro provedení změn."
      },
      {
        question: "Mohu změnit otázky pohovorů, které jsem vytvořil dříve?",
        answer:
          "Pokud jste pohovor kandidátům ještě neodeslali, můžete otázky přidávat nebo odebírat. Pokud již byl odeslán, můžete aktualizovat pouze název pohovoru."
      },
      {
        question: "Změnil jsem název pohovoru, který jsem dříve odeslal kandidátům. Budou aktualizovány e-maily zaslané kandidátům?",
        answer:
          "Ne. Název slouží pouze pro vaše interní sledování a neovlivňuje e-maily zasílané kandidátům."
      },
      {
        question: "Mohu odeslat jinému pohovoru stejnému kandidátovi do 7 dnů?",
        answer:
          "Ano. Stejnému kandidátovi můžete odeslat neomezený počet pohovorů."
      },
      {
        question: "Jak mohu sdílet výsledky kandidátů se svými kolegy?",
        answer:
          "Existuje více způsobů. Nejjednodušší je sdílení odkazu na výsledky (i pokud nemají účet HireThink). Výsledky můžete také exportovat jako PDF a sdílet je se svým týmem."
      },
      {
        question: "Jak jsou mé žádosti o pohovor sdělovány kandidátům?",
        answer:
          "Pozvánky na video pohovor jsou kandidátům zasílány e-mailem. Pokud se kandidát nedostaví, poslední den je odeslán připomínkový e-mail."
      },
      {
        question: "Jak mohu smazat uživatele — člena týmu?",
        answer:
          "Uživatele můžete smazat v sekci „Správa členů“ výběrem uživatele a kliknutím na „Smazat“."
      },
      {
        question: "Jak mohu upravit informace o uživateli?",
        answer:
          "Klikněte na své uživatelské jméno a otevřete „Upravit profil“ pro aktualizaci jména, příjmení a hesla."
      },
      {
        question: "Kolik HireThink stojí?",
        answer:
          "Záleží na zvoleném plánu. Ceny se liší podle měsíční nebo roční fakturace."
      },
      {
        question: "Mohu zrušit své předplatné?",
        answer:
          "Ano. Předplatné můžete zrušit v sekci informací o předplatném."
      }
    ]
  },
  cookieConsent: {
    title: "O souborech cookie",
    description: "Tento web používá soubory cookie ke zlepšení vašeho zážitku a analýze výkonu webu. Více informací o používání cookies najdete v našich",
    learnMore: "zásadách cookies",
    acceptAll: "Přijmout vše",
    rejectAll: "Odmítnout vše",
    settings: "Nastavení",
    settingsTitle: "Předvolby cookies",
    settingsDescription: "Můžete si vybrat z následujících kategorií cookies:",
    necessaryTitle: "Nezbytné cookies",
    necessaryDesc: "Cookies nezbytné pro fungování webu. Tyto cookies nelze vypnout.",
    functionalTitle: "Funkční cookies",
    functionalDesc: "Cookies, které nám pomáhají zapamatovat si vaše uživatelská nastavení, jako jsou jazykové preference.",
    analyticsTitle: "Analytické cookies",
    analyticsDesc: "Cookies, které nám pomáhají pochopit, jak je web používán (Google Analytics apod.).",
    marketingTitle: "Marketingové cookies",
    marketingDesc: "Cookies, které nám pomáhají zobrazovat vám relevantnější obsah a reklamy.",
    cookiePolicy: "Zásady cookies",
    cancel: "Zrušit",
    savePreferences: "Uložit předvolby"
  },
  paymentModal: {
    invoiceInfo: "Fakturační údaje",
    payment: "Platba",
    yearly: "Ročně",
    monthly: "Měsíčně",
    close: "Zavřít",
    companyInfo: "Informace o společnosti",
    companyName: "Název společnosti",
    companyNamePlaceholder: "Zadejte název své společnosti",
    taxNumber: "Daňové číslo",
    taxNumberPlaceholder: "Zadejte své daňové číslo",
    taxOffice: "Finanční úřad",
    taxOfficePlaceholder: "Zadejte název svého finančního úřadu",
    address: "Adresa",
    addressPlaceholder: "Zadejte adresu své společnosti",
    authorizedPersonName: "Jméno oprávněné osoby",
    authorizedPersonNamePlaceholder: "Zadejte své jméno",
    authorizedPersonSurname: "Příjmení oprávněné osoby",
    authorizedPersonSurnamePlaceholder: "Zadejte své příjmení",
    email: "E-mail",
    emailPlaceholder: "priklad@spolecnost.cz",
    phone: "Telefonní číslo",
    phonePlaceholder: "+420 555 123 456",
    required: "povinné",
    invalidEmail: "Zadejte prosím platnou e-mailovou adresu",
    invalidPhone: "Zadejte prosím platné telefonní číslo",
    orderSummary: "Souhrn objednávky",
    plan: "Plán:",
    period: "Období:",
    unitPrice: "Jednotková cena:",
    total12Months: "Celkem (12 měsíců):",
    subtotal: "Mezisoučet:",
    vat: "DPH (20 %):",
    total: "Celkem:",
    exchangeRateNote: "* Směnný kurz: 1 $ = {{rate}} ₺",
    proceedToPayment: "Pokračovat k platbě",
    cardInfo: "Údaje o platební kartě",
    cardNumber: "Číslo karty",
    cardNumberPlaceholder: "1234 5678 9012 3456",
    cardName: "Jméno držitele karty",
    cardNamePlaceholder: "JMÉNO PŘÍJMENÍ",
    expiryDate: "Datum platnosti",
    expiryDatePlaceholder: "MM/RR",
    cvv: "CVV",
    cvvPlaceholder: "123",
    paymentSummary: "Souhrn platby",
    back: "Zpět",
    processing: "Zpracování...",
    pay: "Zaplatit",
    paymentFailed: "Platba se nezdařila",
    paymentFailedMessage: "Došlo k chybě, platba nebyla provedena",
    requiredField: "*",
    month: "Měsíc",
    months: "Měsíců"
  },
  interviewObserver: {
    badge: "AI pozorovatel pohovoru",
    heroTitle1: "Neutrální AI pozorovatel",
    heroTitle2: "se připojí k vašemu živému pohovoru",
    heroSubtitle: "HireThink Observer se tiše připojí k vašemu hovoru na Google Meet, Zoom nebo Teams a objektivně hodnotí jak kandidáta, tak HR tazatele. Zajistěte spravedlnost, kvalitu a právní soulad v každém pohovoru pomocí AI.",
    floatBadge1Title: "Živé sledování",
    floatBadge1Desc: "Analýza v reálném čase",
    floatBadge2Title: "Neutrální hodnocení",
    floatBadge2Desc: "Objektivní pro obě strany",
    floatBadge3Title: "Podrobný report",
    floatBadge3Desc: "Analýza po pohovoru",
    howTitle: "Jak to funguje",
    howSubtitle: "Připojí se jako meeting bot, vše pozoruje a vygeneruje komplexní report",
    step1Title: "Pozvěte bota",
    step1Desc: "Sdílejte odkaz na bota HireThink Observer na schůzce s pohovorem. Automaticky se připojí k Zoom, Google Meet nebo Teams.",
    step2Title: "Tiché pozorování",
    step2Desc: "Bot se připojí jako tichý pozorovatel a analyzuje audio a video přenosy v reálném čase, aniž by zasahoval do konverzace.",
    step3Title: "Živá upozornění",
    step3Desc: "Když jsou zjištěny sugestivní otázky, diskriminační jazyk nebo problémy s kvalitou pohovoru, HR manažeři dostávají okamžitá upozornění.",
    step4Title: "Prohlédněte si report",
    step4Desc: "Jakmile pohovor skončí, jsou do vašeho systému dodány samostatné komplexní hodnoticí reporty jak pro kandidáta, tak pro HR tazatele.",
    featuresTitle: "Funkce Observer bota",
    featuresSubtitle: "AI, která celostně hodnotí proces pohovoru z pohledu kandidáta i HR",
    feature1Title: "Pozorování v reálném čase",
    feature1Desc: "Bot se připojí jako tichý pozorovatel a zpracovává konverzace, tón, otázky a odpovědi během milisekund, aby vytvořil živé metriky.",
    feature2Title: "Analýza HR zaujatosti",
    feature2Desc: "Hodnotí otázky tazatele z HR z hlediska právního souladu, neutrality a profesionality. Automaticky označuje diskriminační nebo sugestivní vzorce otázek.",
    feature3Title: "Audit právního souladu",
    feature3Desc: "Detekuje otázky dotýkající se rizikových oblastí diskriminace, jako je věk, pohlaví, rodinný stav nebo náboženství. Chrání vaši firmu před právními riziky.",
    feature4Title: "Skóre kompetencí kandidáta",
    feature4Desc: "Hodnotí odpovědi kandidáta na základě obsahu, plynulosti, sebedůvěry a indikátorů kompetencí. Generuje srovnatelná standardní skóre napříč všemi pohovory.",
    feature5Title: "Komplexní report pohovoru",
    feature5Desc: "Po každém pohovoru je samostatně vygenerován report HR výkonu a report hodnocení kandidáta. Sdílitelný, exportovatelný formát.",
    feature6Title: "V souladu s GDPR a KVKK",
    feature6Desc: "Veškerá analýza zvuku a videa je zpracovávána na šifrované infrastruktuře. Účastníci jsou informováni a data jsou spravována v souladu se zákonnými lhůtami uchovávání.",
    reportTitle: "Oboustranný hodnoticí report",
    reportSubtitle: "Po skončení pohovoru jsou automaticky vygenerovány komplexní samostatné reporty jak pro kandidáta, tak pro HR pracovníka",
    reportCandidateTitle: "Report kandidáta",
    reportCandidate1: "Skóre založené na kompetencích a podrobná analýza",
    reportCandidate2: "Hodnocení verbální plynulosti a sebedůvěry",
    reportCandidate3: "Silné stránky a oblasti rozvoje",
    reportCandidate4: "Srovnávací benchmark vůči ostatním kandidátům",
    reportHrTitle: "Report HR výkonu",
    reportHr1: "Skóre kvality a neutrality otázek",
    reportHr2: "Detekované rizikové vzorce otázek",
    reportHr3: "Analýza délky a průběhu pohovoru",
    reportHr4: "Hodnocení profesionality a právního souladu",
    ctaTitle: "Učiňte každý pohovor neprůstřelným",
    ctaSubtitle: "S HireThink Observer je každý pohovor neutrální, standardizovaný a právně zabezpečený.",
    ctaButton: "Vyžádat ukázku"
  },
  newsletter: {
    badge: "Týdenní newsletter",
    heroTitle1: "Kam AI",
    heroTitle2: "posouvá HR?",
    heroSubtitle: "Sledujte AI transformaci, která mění nábor, hodnocení talentů a zkušenost zaměstnanců — každý týden přímo do vaší schránky. Buďte o krok napřed před konkurencí.",
    pill1: "Novinky z AI",
    pill2: "Trendy v HR",
    pill3: "Týdenní přehled",
    formBadge: "Zdarma · Týdně · Kdykoli zrušitelné",
    formTitle: "Buďte o krok napřed v HR a AI",
    formSubtitle: "Získávejte AI průlomy, které mění nábor, výjimečné HR strategie a oborové trendy přímo do své schránky každý týden. Přihlášení zdarma, kdykoli zrušitelné.",
    firstName: "Jméno",
    firstNamePlaceholder: "Vaše jméno",
    lastName: "Příjmení",
    lastNamePlaceholder: "Vaše příjmení",
    email: "E-mail",
    emailPlaceholder: "priklad@email.com",
    phone: "Telefon",
    phonePlaceholder: "+420 555 123 456",
    companyName: "Název společnosti",
    companyNamePlaceholder: "Název vaší společnosti",
    title: "Pracovní pozice",
    titlePlaceholder: "např. HR manažer",
    department: "Oddělení",
    departmentPlaceholder: "např. Lidské zdroje",
    birthDate: "Datum narození",
    consentText: "Souhlasím se zasíláním týdenního newsletteru, aktualizací produktu a oborových novinek od HireThink. Vím, že se mohu kdykoli odhlásit.",
    submit: "Přihlásit se k odběru",
    submitting: "Přihlašování...",
    privacy: "Vaše osobní údaje jsou chráněny podle GDPR. Vaše informace nebudou sdíleny s třetími stranami.",
    successTitle: "Jste přihlášeni k odběru!",
    successDesc: "Žádný vývoj v AI a HR vám neunikne. Každý týden vám přineseme průlomy, které mění nábor, hodnocení talentů a zkušenost zaměstnanců — přímo do vaší schránky.",
    successUnsubscribe: "Odběr můžete kdykoli zrušit kliknutím na odkaz „Odhlásit se“ v jakémkoli e-mailu newsletteru.",
    counterLabel: "lidí je již v obraze",
    counterSub: "Připojte se k nim a buďte o krok napřed.",
    errorRequired: "Toto pole je povinné.",
    errorEmail: "Zadejte prosím platnou e-mailovou adresu.",
    errorConsent: "Pro pokračování musíte souhlasit s odběrem newsletteru.",
    errorGeneric: "Něco se pokazilo. Zkuste to prosím znovu."
  }
};

export default cs;
